(function () {
  var AREAS = {
    melbourne_metro: { state: 'VIC', lat: [-38.43, -37.48], lng: [144.55, 145.65] },
    geelong: { state: 'VIC', lat: [-38.25, -38.02], lng: [144.25, 144.5] },
    sydney_metro: { state: 'NSW', lat: [-34.15, -33.55], lng: [150.62, 151.35] },
    newcastle: { state: 'NSW', lat: [-33.05, -32.78], lng: [151.55, 151.85] },
    wollongong: { state: 'NSW', lat: [-34.55, -34.35], lng: [150.75, 150.98] },
    brisbane_metro: { state: 'QLD', lat: [-27.72, -27.25], lng: [152.75, 153.25] },
    gold_coast: { state: 'QLD', lat: [-28.2, -27.8], lng: [153.2, 153.55] },
    sunshine_coast: { state: 'QLD', lat: [-26.85, -26.35], lng: [152.85, 153.15] },
    perth_metro: { state: 'WA', lat: [-32.45, -31.65], lng: [115.68, 116.15] },
    adelaide_metro: { state: 'SA', lat: [-35.2, -34.7], lng: [138.45, 138.78] },
    hobart: { state: 'TAS', lat: [-42.98, -42.78], lng: [147.2, 147.45] },
    darwin: { state: 'NT', lat: [-12.55, -12.3], lng: [130.8, 131.05] },
    canberra: { state: 'ACT', lat: [-35.5, -35.12], lng: [148.98, 149.25] }
  };

  var STATE_NAMES = {
    VIC: 'VICTORIA',
    NSW: 'NEW SOUTH WALES',
    QLD: 'QUEENSLAND',
    SA: 'SOUTH AUSTRALIA',
    WA: 'WESTERN AUSTRALIA',
    TAS: 'TASMANIA',
    NT: 'NORTHERN TERRITORY',
    ACT: 'AUSTRALIAN CAPITAL TERRITORY'
  };

  var storageKey = 'kl-metro-shipping-note';
  var dismissFor = 30 * 24 * 60 * 60 * 1000;
  var editorBound = false;

  function readConfig(scope) {
    var node = (scope || document).querySelector('[data-kl-location-note-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function dismissed() {
    try {
      var saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
      return !!(saved && saved.until > Date.now());
    } catch (error) {
      return false;
    }
  }

  function rememberDismissal() {
    try {
      localStorage.setItem(storageKey, JSON.stringify({ until: Date.now() + dismissFor }));
    } catch (error) {}
  }

  function stateMatches(place, code) {
    var regionCode = String(place.region_code || '').toUpperCase().replace(/^AU-/, '');
    var region = String(place.region || '').toUpperCase();
    return regionCode === code || region === code || region === STATE_NAMES[code];
  }

  function cityMatches(place, city) {
    var wanted = String(city || '').trim().toLowerCase();
    if (!wanted) return false;
    var got = String(place.city || '').trim().toLowerCase();
    return got === wanted || got.indexOf(wanted) !== -1;
  }

  function inArea(place, area) {
    var box = AREAS[area];
    if (!box || !stateMatches(place, box.state)) return false;
    var lat = Number(place.latitude);
    var lng = Number(place.longitude);
    if (!isFinite(lat) || !isFinite(lng)) return false;
    return lat >= box.lat[0] && lat <= box.lat[1] && lng >= box.lng[0] && lng <= box.lng[1];
  }

  function matches(place, location) {
    if (!location || location.enabled === false) return false;
    if (!place || place.success === false) return false;
    if (String(place.country_code || '').toUpperCase() !== 'AU') return false;

    if (location.area && location.area !== 'whole_state' && location.area !== 'custom_city') {
      return inArea(place, location.area);
    }

    if (!stateMatches(place, location.state)) return false;
    if (location.area === 'custom_city') return cityMatches(place, location.city);
    return location.area === 'whole_state';
  }

  function specificity(location) {
    return location.area === 'whole_state' ? 1 : 2;
  }

  function matchingLocation(place, locations) {
    var best = null;
    var bestScore = 0;
    (locations || []).forEach(function (location) {
      if (!matches(place, location)) return;
      var score = specificity(location);
      if (score > bestScore) {
        best = location;
        bestScore = score;
      }
    });
    return best;
  }

  function locationById(locations, id) {
    for (var i = 0; i < locations.length; i++) {
      if (locations[i].id === id) return locations[i];
    }
    return null;
  }

  function init(scope) {
    var note = (scope || document).querySelector('[data-kl-location-note]');
    if (!note || note.getAttribute('data-kl-ready') === 'true') return;
    var config = readConfig(note.parentNode || document);
    if (!config || !config.locations || !config.locations.length) return;

    note.setAttribute('data-kl-ready', 'true');

    var label = note.querySelector('[data-kl-location-note-label]');
    var message = note.querySelector('[data-kl-location-note-message]');
    var hideTimer = null;
    var hideDelay = null;

    function applyCopy(location) {
      label.textContent = location.label || '';
      message.textContent = location.message || '';
    }

    function show(location, autoHide) {
      if (!location || !location.message) return;
      window.clearTimeout(hideTimer);
      window.clearTimeout(hideDelay);
      applyCopy(location);
      note.hidden = false;
      window.requestAnimationFrame(function () {
        note.classList.add('is-visible');
      });
      if (autoHide) {
        hideTimer = window.setTimeout(function () {
          hide(true);
        }, Number(config.hideAfter || 8) * 1000);
      }
    }

    function hide(persist) {
      window.clearTimeout(hideTimer);
      note.classList.remove('is-visible');
      window.clearTimeout(hideDelay);
      hideDelay = window.setTimeout(function () {
        note.hidden = true;
      }, 250);
      if (persist) rememberDismissal();
    }

    note.querySelector('[data-kl-location-note-close]').addEventListener('click', function () {
      hide(!config.designMode);
    });

    if (config.designMode) return;

    if (dismissed()) return;

    var controller = window.AbortController ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 4000);

    fetch('https://ipwho.is/', {
      signal: controller ? controller.signal : undefined,
      credentials: 'omit'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('location unavailable');
        return response.json();
      })
      .then(function (place) {
        window.clearTimeout(timer);
        var location = matchingLocation(place, config.locations);
        if (location) window.setTimeout(function () { show(location, true); }, 1200);
      })
      .catch(function () {
        window.clearTimeout(timer);
      });
  }

  function currentNote() {
    return document.querySelector('[data-kl-location-note]');
  }

  function fillNote(note, location) {
    var label = note.querySelector('[data-kl-location-note-label]');
    var message = note.querySelector('[data-kl-location-note-message]');
    if (label) label.textContent = location.label || '';
    if (message) message.textContent = location.message || '';
    note.hidden = false;
    window.requestAnimationFrame(function () {
      note.classList.add('is-visible');
    });
  }

  function previewBlock(id) {
    var note = currentNote();
    var config = note ? readConfig(note.parentNode || document) : null;
    if (!note || !config || !config.designMode) return;
    if (note.getAttribute('data-kl-ready') !== 'true') init(note.parentNode || document);
    var location = (id && locationById(config.locations, id)) || config.locations[0];
    if (location) fillNote(note, location);
  }

  function bindEditor() {
    if (editorBound) return;
    editorBound = true;

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target || !event.target.querySelector('[data-kl-location-note]')) return;
      init(event.target);
      var config = readConfig(event.target);
      if (config && config.designMode && config.locations[0]) {
        fillNote(event.target.querySelector('[data-kl-location-note]'), config.locations[0]);
      }
    });

    document.addEventListener('shopify:section:select', function (event) {
      if (!event.target || !event.target.querySelector('[data-kl-location-note]')) return;
      previewBlock(null);
    });

    document.addEventListener('shopify:section:deselect', function (event) {
      var note = event.target && event.target.querySelector('[data-kl-location-note]');
      if (!note) return;
      note.classList.remove('is-visible');
      note.hidden = true;
    });

    document.addEventListener('shopify:block:select', function (event) {
      var id = event.detail && event.detail.blockId;
      window.setTimeout(function () { previewBlock(id); }, 0);
    });
  }

  bindEditor();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
